import { ServiceApiBaseUrls } from '../../models/service-api-base-urls';

export const serviceApiBaseUrls = new ServiceApiBaseUrls({
  authWsApiBaseUrl: 'https://authws-qa.alk.com',
  authenticationApiBaseUrl: 'https://authentication-api-qa.trimblemaps.com',
  trimbleIdentityApiBaseUrl: 'https://stage.id.trimblecloud.com',
  tripManagementSettingsApiBaseUrl: 'https://tripmanagement-qa.trimblemaps.com',
  cpihMessageExporterApiBaseUrl: 'https://cpih-apigateway-qa.trimblemaps.com',
  partnerBundleApiBaseUrl: 'https://partnerbundle-api-qa.trimblemaps.com',

  cloudProviderApiBaseUrls: {
    AWS: {
      accountsApiBaseUrl: 'https://accounts-api-qa.trimblemaps.com',
      auditLogApiBaseUrl: 'https://audit-log-qa.trimblemaps.com',
      fleetApiBaseUrl: 'https://fleets-qa.trimblemaps.com',
      fleetStatsApiBaseUrl: 'https://fleet-stats-qa.trimblemaps.com',
      routingProfileServiceApiBaseUrl: 'https://api-qa.trimblemaps.com',
      copilotMessagePublisherApiBaseUrl:
        'https://copilot-message-publisher-qa.trimblemaps.com',
      enterpriseLogsServiceApiBaseUrl:
        'https://enterprise-logs-service-qa.trimblemaps.com',
      cpihApiBaseUrl:
        'https://cpih-integration-partner-auth-validator-service-qa.trimblemaps.com',
      mobileInstructionsApiBaseUrl:
        'https://mobile-instruction-service-qa.trimblemaps.com',
      smsNotificationServiceApiBaseUrl:
        'https://sms-notification-service-qa.trimblemaps.com',
      licenseTrackerApiBaseUrl: 'https://api-qa.trimblemaps.com',
      mapManagementServiceApiBaseUrl:
        'https://map-management-qa.trimblemaps.com',
      pcMilerWebServicesApiBaseUrl:
        'https://pcmiler-aws-qa.alk.com/APIs/REST/v1.0/service.svc',
      placesApiBaseUrl: 'https://api-qa.trimblemaps.com',
    },
    Azure: {
      accountsApiBaseUrl: 'https://accounts-api-qa.azqa.trimblemaps.com',
      auditLogApiBaseUrl: 'https://audit-log-qa.azqa.trimblemaps.com',
      fleetApiBaseUrl: 'https://fleets-qa.azqa.trimblemaps.com',
      fleetStatsApiBaseUrl:
        'https://fleetstats-service-qa.azqa.trimblemaps.com',
      routingProfileServiceApiBaseUrl: 'https://api-qa.azqa.trimblemaps.com',
      copilotMessagePublisherApiBaseUrl:
        'https://copilot-message-publisher-qa.azqa.trimblemaps.com',
      enterpriseLogsServiceApiBaseUrl:
        'https://enterprise-logs-service-qa.azqa.trimblemaps.com',
      cpihApiBaseUrl:
        'https://cpih-integration-partner-auth-validator-service-qa.azqa.trimblemaps.com',
      mobileInstructionsApiBaseUrl:
        'https://mobile-instruction-service-qa.azqa.trimblemaps.com',
      smsNotificationServiceApiBaseUrl:
        'https://sms-notification-service-qa.azqa.trimblemaps.com',
      licenseTrackerApiBaseUrl: 'https://api-qa.azqa.trimblemaps.com',
      mapManagementServiceApiBaseUrl:
        'https://map-management-qa.azqa.trimblemaps.com',
      pcMilerWebServicesApiBaseUrl:
        'https://pcmiler-aws-qa.azqa.alk.com/APIs/REST/v1.0/service.svc',
      placesApiBaseUrl: 'https://places-api-qa.azqa.trimblemaps.com',
    },
  },
});
